function aiUploadHandler() {

  return {

    showModal: false,

    croppedImageUrl: '',

    cropper: null,



    // =========================
    // 文件选择
    // =========================

    onFileChange(e) {


      const file = e.target.files[0];


      if (!file) return;



      const reader = new FileReader();



      reader.onload = (event) => {


        this.openModal(
          event.target.result
        );


      };



      reader.readAsDataURL(file);



      // 允许重复选择同一张图片

      e.target.value = '';

    },





    // =========================
    // 打开裁剪窗口
    // =========================

    openModal(src) {


      this.showModal = true;



      this.$nextTick(() => {



        const img =
        this.$refs.cropImage;



        if(!img) return;




        img.src = src;



        img.onload = () => {



          if(this.cropper){


            this.cropper.destroy();


          }





          this.cropper =
          new Cropper(
            img,
            {


              aspectRatio: NaN,


              viewMode:1,


              autoCropArea:0.8,


              responsive:true,


              movable:true,


              scalable:true,


              zoomable:true,



              ready:()=>{


                this.cropper.setDragMode(
                  'move'
                );


              }


            }
          );



        };




        if(img.complete){


          img.onload();


        }



      });


    },





    // =========================
    // 删除上传照片
    // =========================

    removeUploadedPhoto(){


      // 清除页面预览

      this.croppedImageUrl = '';



      // 清除 AI 使用文件

      window.currentUploadedFile = null;




      // 销毁裁剪器

      if(this.cropper){


        this.cropper.destroy();


        this.cropper = null;


      }




      // 清空上传input

      if(this.$refs.fileInput){


        this.$refs.fileInput.value = '';


      }




      console.log(
        "[System] Uploaded photo removed"
      );


    },






    // =========================
    // 调整已有图片
    // =========================

    openExistingCrop(){


      if(this.croppedImageUrl){


        this.openModal(
          this.croppedImageUrl
        );


      }


    },






    // =========================
    // 关闭裁剪窗口
    // =========================

    closeModal(){


      this.showModal=false;



      if(this.cropper){


        this.cropper.destroy();


        this.cropper=null;


      }


    },






    // =========================
    // 确认裁剪
    // =========================

    confirmCrop(){


      if(!this.cropper) return;





      const canvas =
      this.cropper.getCroppedCanvas({

        width:1024,

        height:1024

      });






      if(canvas){



        this.croppedImageUrl =
        canvas.toDataURL(
          'image/jpeg',
          0.9
        );





        canvas.toBlob(
          (blob)=>{



            if(blob){



              const croppedFile =
              new File(
                [
                  blob
                ],
                "user-cropped-photo.jpg",
                {
                  type:"image/jpeg"
                }
              );




              window.currentUploadedFile =
              croppedFile;




              console.log(
                "[System] File generated successfully:",
                croppedFile
              );



            }



          },
          'image/jpeg',
          0.9
        );



      }





      this.closeModal();


    }



  }

}